import { HttpInterceptorFn } from '@angular/common/http';
import { API_BASE_URL } from '../config/api-config';
import { isSupportedLanguage } from '../i18n/supported-languages';

const LANGUAGE_STORAGE_KEY = 'speed.lang';
const DEFAULT_LANGUAGE = 'en';

function resolveActiveLanguage(): string {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  const storedLang = stored?.trim();
  if (isSupportedLanguage(storedLang)) {
    return storedLang;
  }

  const docLang = document.documentElement.lang?.trim();
  if (isSupportedLanguage(docLang)) {
    return docLang;
  }

  return DEFAULT_LANGUAGE;
}

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(`${API_BASE_URL}`)) return next(req);

  const language = resolveActiveLanguage();
  const headers = req.headers.has('Accept-Language')
    ? req.headers
    : req.headers.set('Accept-Language', language);

  return next(req.clone({ headers }));
};
